import React, { useState } from 'react';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { ref, set } from 'firebase/database';
import { auth, database } from '../firebaseConfig';
import { useAuth } from '../context/AuthContext';
import { TEMP_PASSWORD } from '../context/AuthContext';

// Shown after sign-in while users/<uid>/mustChangePassword is true (accounts on the temporary password).
export default function ChangePasswordGate() {
  const { clearMustChangePassword, logout } = useAuth();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 6) return setError('Use at least 6 characters.');
    if (pw !== pw2) return setError('The two passwords do not match.');
    if (pw.toLowerCase() === TEMP_PASSWORD) return setError('Pick something other than the temporary password.');
    const u = auth.currentUser;
    if (!u) return setError('Please sign in again.');
    setBusy(true);
    try {
      try { await updatePassword(u, pw); } catch (err) {
        if (err?.code !== 'auth/requires-recent-login') throw err;
        await reauthenticateWithCredential(u, EmailAuthProvider.credential(u.email, TEMP_PASSWORD));
        await updatePassword(u, pw);
      }
      await set(ref(database, `users/${u.uid}/mustChangePassword`), false);
      clearMustChangePassword();
    } catch (err) {
      setError(err?.code === 'auth/weak-password' ? 'That password is too weak. Try a longer one.' : `Could not save your password (${err?.code || err?.message || 'error'}). Please try again.`);
    } finally { setBusy(false); }
  };

  return (
    <div style={s.wrap}>
      <form onSubmit={submit} style={s.card}>
        <img src="/residence-exp-logo-white.png" alt="RESIDENCE | eXp Realty" style={s.logo} />
        <h2 style={s.h}>Set your new password</h2>
        <p style={s.p}>Welcome to Resi! Choose your own password to replace the temporary one.</p>
        <input type="password" autoComplete="new-password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} style={s.in} />
        <input type="password" autoComplete="new-password" placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} style={s.in} />
        {error && <p style={s.err}>{error}</p>}
        <button type="submit" disabled={busy} style={s.btn}>{busy ? 'Saving…' : 'Save and continue'}</button>
        <button type="button" onClick={() => logout()} style={s.link}>Sign out</button>
      </form>
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', background: '#000', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  card: { width: '100%', maxWidth: 380, background: '#111', border: '1px solid #333', borderRadius: 10, padding: 24, color: '#fff', display: 'flex', flexDirection: 'column', gap: 12 },
  logo: { width: 220, maxWidth: '80%', margin: '0 auto 8px' },
  h: { margin: 0, color: '#D4AF37', textAlign: 'center' },
  p: { margin: 0, color: '#ccc', fontSize: 14, textAlign: 'center' },
  in: { padding: 12, borderRadius: 6, border: '1px solid #444', background: '#000', color: '#fff', fontSize: 16 },
  err: { margin: 0, color: '#ff6b6b', fontSize: 14 },
  btn: { padding: 12, borderRadius: 6, border: 0, background: '#D4AF37', color: '#000', fontWeight: 700, fontSize: 16, cursor: 'pointer' },
  link: { background: 'none', border: 0, color: '#999', cursor: 'pointer', fontSize: 13 },
};
